/* Native modal and native Shopify form: do not fake signup success with JS. */
(() => {
  'use strict';
  const KEY = 'brezi:new-color-01';
  const read = (storage, key) => { try { return storage.getItem(key); } catch (_) { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, value); } catch (_) { /* Private browsing: in-memory only. */ } };
  // Accessing the storage getter itself can throw in restricted browsers.
  const storage = name => { try { return window[name]; } catch (_) { return null; } };
  const local = storage('localStorage');
  const session = storage('sessionStorage');

  function init(dialog) {
    if (dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
    dialog.dataset.initialized = 'true';
    const form = dialog.querySelector('form');
    const image = dialog.querySelector('[data-color-src]');
    const designMode = dialog.dataset.designMode === 'true';
    // This is a public form, not gated content. An explicit preview URL may
    // reopen it on the published site without resetting normal visitor timing.
    const forced = new URLSearchParams(window.location.search).get('brezi_color_preview') === '1';
    const delay = Number(dialog.dataset.delay || 5) * 1000;
    const successful = dialog.querySelector('[data-color-success]');
    const errors = dialog.querySelector('[data-color-error]');
    const pending = read(session, KEY + ':pending');
    // Several Shopify customer forms can share the same server form state. Only
    // reopen this popup for its own submission, not the footer newsletter form.
    const ownResponse = (successful || errors) &&
      ((Number(pending) > Date.now() - 900000) || window.location.hash === '#' + form.id);
    let timer;
    let shown = false;
    let previousFocus;
    let previousOverflow;
    let pointerStartedOutside = false;

    const blocked = () => document.hidden ||
      Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden]):not([aria-hidden="true"])')).some(other => other.getClientRects().length > 0) ||
      (document.activeElement && document.activeElement.matches('input,textarea,select,[contenteditable="true"]'));
    // Dismissal lasts only for this page load. Ignore legacy seen/shown markers
    // so returning visitors do not retain the former seven-day suppression.
    const eligible = () => read(local, KEY + ':subscribed') !== '1';

    function close() { if (dialog.open) dialog.close(); }
    function open(bypass = false) {
      if (dialog.open || (!bypass && (shown || !eligible()))) return true;
      if (!bypass && blocked()) return false;
      if (image && !image.src) {
        image.srcset = image.dataset.colorSrcset;
        image.src = image.dataset.colorSrc;
      }
      previousFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      shown = true;
      // Do not summon a mobile keyboard on automatic display.
      const focus = ownResponse ? successful || errors : dialog.querySelector('.bzc-close');
      if (focus) focus.focus({preventScroll:true});
      return true;
    }
    function schedule() {
      if (!eligible() || shown || designMode) return;
      if (!open()) timer = window.setTimeout(schedule, 2000);
    }

    dialog.querySelectorAll('[data-color-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow || '';
      if (previousFocus && previousFocus.isConnected) previousFocus.focus({preventScroll:true});
    });
    const outside = event => {
      const rect = dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    };
    dialog.addEventListener('pointerdown', event => { pointerStartedOutside = outside(event); });
    dialog.addEventListener('click', event => { if (pointerStartedOutside && outside(event)) close(); });
    form.addEventListener('submit', () => {
      // No preventDefault: preserve Shopify validation, spam protection and redirects.
      write(session, KEY + ':pending', String(Date.now()));
      // Let Shopify/hCaptcha place any challenge outside this modal without
      // the native dialog's inert background blocking its controls.
      close();
    });
    if (ownResponse) {
      if (successful) write(local, KEY + ':subscribed', '1');
      write(session, KEY + ':pending', '');
      open(true);
    } else if (forced) {
      open(true);
    } else if (!designMode && !successful && !errors && eligible()) {
      timer = window.setTimeout(schedule, delay);
    }
    document.addEventListener('shopify:section:select', event => {
      if (designMode && event.target.contains(dialog)) open(true);
    });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(dialog)) { window.clearTimeout(timer); close(); }
    });
  }
  document.querySelectorAll('[data-brezi-color]').forEach(init);
})();
